module.exports = {
	sub:{
		newipo: 'IPO Application',
		comname: 'Company Name',
		nature:'Business Nature',
		market:'Market',
		status:'Listing Status',
		subdata:'Submission Date',
		profile:'Company Profile',
		stockname:'Stock Name',
		stockcode:'Stock Code',
		sponsor:'Sponsor',
		ldata:'Listing Date',
		efee:'Entry Fee',
		Board:'Board Lot',
		Period:'Application Period',
		grey:'Grey Market Date',
		rate:'Over-sub. Rate',
		price :'Offer Price',
		cancel:'Cancel',
		cname:'Please use the semicolon ( ; ) for multiple sponsors',
		save:'Save',
		Prospectus:'prospectus',
		Editipo:'IPO Edit',
		ipomessage:'Details of new shares',
		jeb:'Amount statement',
		dkbl:'Loan ratio',
		rs:'Days',
		lx:'Interest rate',
		langan:'Please upload data first',
		sqsl:'Number of applications',
		sqje:'Application amount',
		confirm:'confirm',
		pln:'Please fill in'
	}
}